const ButtonTag = (props) => {
  let { className, btnName, btnOnClickHandler } = props;
  return (
    <>
      <button className={className} onClick={btnOnClickHandler}>
        {btnName}
      </button>
    </>
  );
};

export default ButtonTag;
